(function () {
    "use strict";

    var app = angular.module('iMatApp');
    app.factory('utils', [
        function () {

            return {
                isEmpty: isEmpty,
                isNumber: isNumber,
                stringIsNumber: stringIsNumber,
                round: round,
                roundMoney: roundMoney,
                roundWeight: roundWeight,
                roundDimensions: roundDimensions,
                sum: sum,
                dateToSqlFormat: dateToSqlFormat,

                array: {
                    insert: insertToArray,
                    remove: removeFromArray
                }
            };

            function isEmpty(viewValue) {
                if (angular.isArray(viewValue)) {
                    return angular.length > 0;
                }

                return angular.isUndefined(viewValue) || viewValue === null || viewValue === "";
            }

            function isNumber(value) {
                return angular.isNumber(value) || stringIsNumber(value);
            }

            function stringIsNumber(s) {
                var x = +s; // made cast obvious for demonstration
                return x.toString() === s;
            }

            function sum(array, iteratee) {
                if (!angular.isFunction(iteratee)) {
                    iteratee = function (obj) {
                        return obj;
                    }
                }

                var result = array.reduce(function (a, b) {
                    return a + iteratee(b);
                }, 0);

                return result;
            }

            // http://stackoverflow.com/a/21482470/5851865
            function dateToSqlFormat(date) {
                return date.getUTCFullYear() + '-' +
                    ('00' + (date.getUTCMonth() + 1)).slice(-2) + '-' +
                    ('00' + date.getUTCDate()).slice(-2) + ' ' +
                    ('00' + date.getUTCHours()).slice(-2) + ':' +
                    ('00' + date.getUTCMinutes()).slice(-2) + ':' +
                    ('00' + date.getUTCSeconds()).slice(-2);
            }

            function round(value, precision) {
                if (!angular.isUndefined(precision) && angular.isNumber(precision)) {
                    var multiplier = Math.pow(10, precision);
                    return Math.round(value * multiplier) / multiplier;
                } else {
                    return Math.round(value * 100) / 100;
                }
            }

            function roundMoney(value) {
                return round(value, 2);
            }

            function roundWeight(value) {
                return round(value, 3);
            }

            function roundDimensions(dims, precision) {
                return {
                    w: round(dims.w, precision),
                    h: round(dims.h, precision),
                    l: round(dims.l, precision)
                };
            }

            // ************************************************** Array ***************************************************

            function insertToArray(array, index, item) {
                array.splice(index, 0, item);
            }

            function removeFromArray(array, item) {
                var index = array.indexOf(item);
                if (index > -1) {
                    array.splice(index, 1);
                }
            }

        }]);
}());